// moduleShape.js — tells the two module formats apart.
//
// Legacy modules kept everything under `content`; their viewer is gone, and
// every module is now in the block format: `microSessions` at the top level,
// each session carrying a `blocks` array rendered by the block kit.
// LearningModuleViewer checks this before rendering.
export const isBlockModule = (module) =>
  Array.isArray(module?.microSessions) &&
  module.microSessions.some((s) => Array.isArray(s?.blocks));

// Micro-sessions regardless of format — used where both shapes are in play
// (module cards, derived duration).
export const getMicroSessions = (module) => {
  if (Array.isArray(module?.microSessions)) return module.microSessions;
  return module?.content?.microSessions || [];
};

// Minutes for a session in either format: `estimatedMinutes: 6` or
// `duration: '6 minutes'`.
export const sessionMinutes = (session) => {
  if (!session) return 0;
  if (typeof session.estimatedMinutes === 'number') return session.estimatedMinutes;
  return parseInt(session.duration, 10) || 0;
};
